/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tea_Purchase_TotalInputs */

const vi_tea_purchase_total = /** @type {(inputs: Tea_Purchase_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng: ${i?.count} đơn`)
};

/**

* @param {Tea_Purchase_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_total = /** @type {((inputs: Tea_Purchase_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_total(inputs)
});